import useQuery from '@api/hooks/useQuery'
import { BasketMonthlyStat } from '@domain'
import { faTimer } from '@fortawesome/pro-light-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Paper, Skeleton, Stack, Typography, useTheme } from '@mui/material'
import { BarChart } from '@mui/x-charts-pro/BarChart'
import MarketBasketReportsApi, { MarketBasketReportsKeys } from '@services/marketBasketReports.api'
import dayjs from 'dayjs'

export default function SixMonAvgStats() {
	const { data, isLoading } = useQuery({
		queryKey: MarketBasketReportsKeys.basketMonthlyAverageStats,
		queryFn: MarketBasketReportsApi.monthlyAverageStats,
	})
	return <SixMonAvgStatsUI data={data || []} isLoading={isLoading} />
}

export function SixMonAvgStatsUI({
	data,
	isLoading = false,
}: {
	data: BasketMonthlyStat[]
	isLoading?: boolean
}) {
	const theme = useTheme()
	const months = data.map((item) => dayjs(item.monthStart).format('MMM'))
	const vals = data.map((item) => item.avgTotalElapsedMinutes)

	return (
		<Paper elevation={1} sx={{ width: '100%' }}>
			<Stack direction="row" spacing={1} p="1rem" alignItems="center">
				<FontAwesomeIcon icon={faTimer} size="lg" />
				<Typography variant="h6">Average Time to Process Market Baskets</Typography>
				<Typography variant="body2" color="text.secondary">
					in minutes
				</Typography>
			</Stack>
			{isLoading || !data ? (
				<Skeleton variant="rectangular" width="100%" height={300} />
			) : (
				<BarChart
					loading={isLoading}
					xAxis={[{ data: months }]}
					series={[
						{
							data: vals,
							valueFormatter: (value) => `${Math.round(value)} mins`,
							color: theme.palette.primary.main,
						},
					]}
					height={300}
					borderRadius={10}
				/>
			)}
		</Paper>
	)
}
